import { Option } from "../../util/option";
import { EnvCopyIfDfnCnvRule } from "../../services/if-conversion-rules";
import { EnvCopyComponentAttrCnvRule } from "../../services/component-conversion-rules";
import { EnvironmentCopyRequest } from "../../services/environment-copy-requests";
import { EnvCopyDeploymentRequestResultDivisionCode } from "../../util/general-code/enums/general-codes";
import { ErrorMessage } from "../../util";

export type EnvironmentCopyPageState = {
  isSaved: boolean;
  isEdited: boolean;
  isDplyInPrgrss: boolean;

  searchResult: {
    envCopyIfDfnCnvRules: EnvCopyIfDfnCnvRule[];
    envCopyCpntAttrCnvRules: EnvCopyComponentAttrCnvRule[];
    environmentCopyRequests: EnvironmentCopyRequest[];
  };

  ifSpreadsheetSelectedRowIndex: number | undefined;
  cpntSpreadsheetSelectedRowIndex: number | undefined;

  dipEnvrnmntSttMngList: DipEnvrnmntSttMng[];
  dipByRgnDropdown: Option[];

  ifItmList: ifItmGrpIfItmLkList[];
  // Dropdown for Component Cnv Rule Spreadsheet
  cpntAttrDropdown: Option[];
  cpntIdDropdown: Option[];

  generalCodes: GnrlCdType[];

  searchConditions: {
    dipByRgnSelected?: string;
    copyFromSelected?: string;
    copyToSelected?: string;
  };
};

type GnrlCdType = {
  cdType: string;
  cdTypeName: string;
  cdList: Option[];
};

export type DipEnvrnmntSttMng = {
  envrnmntId: string;
  envTypeCd: string;
  dipByRgn: string;
  envrnmntIdFrom: string;
};

export type ifItmGrpIfItmLkList = {
  ifItmNum: number;
  ifItmPhysclName: string;
  ifItmLgclName: string;
  ifItmGrpNum: number;
  ifItmGrpLgclName: string;
  ifItmGrpPhycslName: string;
};

export type IfCnvRuleSpreadsheetState = {
  envCopyIfDfnCnvRules: EnvCopyIfDfnCnvRuleRow[];
  ifItmGrpList: Option[];
  isDplyInPrgrss: boolean;
};

export type EnvCopyIfDfnCnvRuleRow = {
  envCopyIfDfnCnvRule: EnvCopyIfDfnCnvRule;
  addFlg: boolean;
  isEdited: boolean;
  delChecked: boolean;
  ifItmDropdown: Option[];
  index?: number;

  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export const displayColumnIfCnvRules = [
  { label: "Component ID", value: "cpntId" },
  { label: "Rule Type", value: "ifDfnCnvRuleTypeCd" },
  { label: "Replace From", value: "rplcmntFromAttrStngVal" },
  { label: "Replace To", value: "rplcmntToAttrStngVal" },
  { label: "Prefix String", value: "prefxStngVal" },
];

export const displayColumnCpntCnvRules = [
  { label: "Component ID", value: "cpntId" },
  { label: "Rule Type", value: "cpntAttrCnvRuleTypeCd" },
  { label: "Replace From", value: "rplcmntFromAttrStngVal" },
  { label: "Replace To", value: "rplcmntToAttrStngVal" },
  { label: "Fix String", value: "attrStngVal" },
];

export type CpntCnvRuleSpreadsheetState = {
  envCopyCpntAttrCnvRules: EnvCopyCpntAttrCnvRuleRow[];
  cpntAttrDropdown: Option[];
  cpntIdDropdown: Option[];
  isDplyInPrgrss: boolean;
};

export type EnvCopyCpntAttrCnvRuleRow = {
  envCopyCpntAttrCnvRule: EnvCopyComponentAttrCnvRule;
  addFlg: boolean;
  isEdited: boolean;
  delChecked: boolean;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type EnvCopyReqSpreadsheetState = {
  environmentCopyRequests: EnvironmentCopyRequestRow[];
  envCopyDeploymentRequestResultDivisionCodeDplymntPending: EnvCopyDeploymentRequestResultDivisionCode.DEPLOYMENT_PENDING;
};

export type EnvironmentCopyRequestRow = {
  environmentCopyRequest: EnvironmentCopyRequest;
  cancel: string | undefined;
};

export type PageNewState =
  | EnvironmentCopyPageState
  | ((prevState: EnvironmentCopyPageState) => EnvironmentCopyPageState);
